export const ActionTypes = {
  SET_THEME: "SET_THEME",
};
